import { createFileRoute, useSearch } from "@tanstack/react-router";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@workspace/ui/components/card";
import { z } from "zod";
import { SingInForm } from "@/features/auth/sign-in-form";

const searchSchema = z.object({
  redirect: z.string().optional(),
});

export const Route = createFileRoute("/(auth)/sign-in")({
  component: SignIn,
  validateSearch: searchSchema,
});

function SignIn() {
  const { redirect } = useSearch({ from: "/(auth)/sign-in" });

  return (
    <Card className="gap-4">
      <CardHeader>
        <CardTitle className="text-lg tracking-tight">Sign in</CardTitle>
        <CardDescription>
          Enter your email and password below to <br />
          log into your account
        </CardDescription>
      </CardHeader>
      <CardContent>
        <SingInForm redirectTo={redirect} />
      </CardContent>
      <CardFooter>
        <p className="px-8 text-center text-muted-foreground text-sm">
          By creating an account, you agree to our Terms of Service and Privacy Policy.
        </p>
      </CardFooter>
    </Card>
  );
}
